export default function WhySection() {
  const cards = [
    {
      emoji: "💰",
      title: "Significant Cost Savings",
      text: "Implants, veneers and full-arch restorations can cost a fraction of UK private prices — often 40–70 % less, even after travel and accommodation.",
    },
    {
      emoji: "🏥",
      title: "High Clinical Standards",
      text: "Many clinics in Hungary, Poland and Spain operate to EU regulatory standards with internationally trained dentists and modern equipment.",
    },
    {
      emoji: "⚠️",
      title: "But Risks Exist",
      text: "Quality varies hugely. Without knowing what to look for — credentials, guarantees, treatment plans — you could end up paying more to fix mistakes.",
    },
    {
      emoji: "📋",
      title: "Our Job: Guide You",
      text: "Dental Safety Abroad gives you the independent information, red-flag warnings, and destination comparisons to make a confident, informed choice.",
    },
  ];

  return (
    <section className="bg-background-50 py-16 md:py-20 lg:py-24" id="why">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600 mb-3 block">
            Why People Choose Treatment Abroad
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            The Savings Are Real — But So Are the Risks
          </h2>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-10 max-w-3xl">
            Dental costs in the UK can be 60–80 % higher than in many European destinations. That&apos;s why thousands of British patients travel each year. We help you navigate it safely.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {cards.map((card) => (
              <div
                key={card.title}
                className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300/60 transition-colors"
              >
                <div className="text-2xl mb-3">{card.emoji}</div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {card.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}